<template>
  <div class="row mt-4" v-if="evolucion.length">
    <div class="col-12">
      <div class="card ficha-listado">
        <div class="px-4 pb-4 card-body">

          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
              <h6 class="mb-0 panel-section-title">Evolución de suscriptores</h6>
              <p class="text-xs opacity-7 mb-0">Altas, bajas y total acumulado mes a mes</p>
            </div>
          </div>

          <!-- KPIs -->
          <div class="row g-2 mb-3">
            <div class="col-6 col-md-3">
              <div class="susc-kpi">
                <div class="susc-kpi__k">Total altas</div>
                <div class="susc-kpi__v susc-kpi__v--verde">+{{ totalAltas }}</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="susc-kpi">
                <div class="susc-kpi__k">Total bajas</div>
                <div class="susc-kpi__v susc-kpi__v--rojo">-{{ totalBajas }}</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="susc-kpi">
                <div class="susc-kpi__k">Neto total</div>
                <div class="susc-kpi__v" :class="netoTotal >= 0 ? 'susc-kpi__v--verde' : 'susc-kpi__v--rojo'">
                  {{ netoTotal >= 0 ? '+' : '' }}{{ netoTotal }}
                </div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="susc-kpi">
                <div class="susc-kpi__k">Activos actuales</div>
                <div class="susc-kpi__v susc-kpi__v--azul">{{ acumuladoFinal }}</div>
              </div>
            </div>
          </div>

          <!-- Gráfico -->
          <QuantySuscriptoresChart
            id="chartSuscriptores"
            :labels="chartData.labels"
            :altas="chartData.altas"
            :bajas="chartData.bajas"
            :acumulado="chartData.acumulado"
          />

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuantySuscriptoresChart from "@/components/charts/QuantySuscriptoresChart.vue";

const MESES = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];
function fmtMes(s) {
  if (!s) return s;
  const [y, m] = s.split("-");
  return `${MESES[parseInt(m) - 1]} '${String(y).slice(2)}`;
}

export default {
  name: "PanelTipsterSuscriptores",
  components: { QuantySuscriptoresChart },
  props: {
    evolucion: { type: Array, default: () => [] },
  },
  computed: {
    chartData() {
      return {
        labels:    this.evolucion.map(d => fmtMes(d.mes)),
        altas:     this.evolucion.map(d => d.altas),
        bajas:     this.evolucion.map(d => d.bajas),
        acumulado: this.evolucion.map(d => d.acumulado),
      };
    },
    totalAltas()     { return this.evolucion.reduce((s, d) => s + d.altas, 0); },
    totalBajas()     { return this.evolucion.reduce((s, d) => s + d.bajas, 0); },
    netoTotal()      { return this.totalAltas - this.totalBajas; },
    acumuladoFinal() { return this.evolucion.length ? this.evolucion[this.evolucion.length - 1].acumulado : 0; },
  },
};
</script>

<style scoped>
.susc-kpi {
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 12px;
  padding: 12px 14px;
  min-height: 72px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
}
.susc-kpi__k {
  font-size: 11px;
  color: var(--q-muted);
  font-family: var(--q-font-ui);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .4px;
}
.susc-kpi__v {
  font-size: 22px;
  font-weight: 800;
  line-height: 1.1;
  color: var(--q-text);
  font-family: var(--q-font-mono);
  font-variant-numeric: tabular-nums;
}
.susc-kpi__v--verde { color: var(--q-green); }
.susc-kpi__v--rojo  { color: var(--q-red); }
.susc-kpi__v--azul  { color: var(--q-gold); }
</style>
